export default __webpack_public_path__ + "static/media/DNo.31-2.e06c9996.jpg";